import React from 'react';

export default function ProgressBar(props) {
    let { current, total } = props;
    let progress = Math.ceil((current / total) * 100);
    return (
        <div className="progress">
            <div
                className="progress-bar"
                role="progressbar"
                aria-valuenow={progress}
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: `${progress}%` }}
            >
                <span className="sr-only">{progress}% Complete</span>
            </div>
        </div>
    );
}
